// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p6HQr","clinicsSelect":"styles_clinicsSelect__2Vzn0"};